import { AdviserWizardDispatcher } from "../Stores/Variable";
import { ActionType } from "../../../../react-core/Flux/ActionType";
import { AdvisersClient } from "../../../../Wrap/Api/Network/Advisers";

export class AdviserWizardAction {
    public static getAdviser(query: any, callback?) {
        const client = new AdvisersClient();
        const readWriteOnly = query?.ReadWriteOnly == true ? true : false;
        const promise = client.get(
            query.Company,
            query.Network,
            query.CurrentPage,
            query.ResultsPerPage,
            readWriteOnly
        );
        promise.onSuccess((data) => {
            AdviserWizardDispatcher.dispatch({
                actionType: ActionType.Success,
                payload: data,
            });
            if (callback) {callback(data);}
        });
        promise.onError((err) => {});
    }
}
